import { AppText } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import QaHiringResourcesInstancesLeaf from "./QaHiringResourcesInstancesLeaf";

const QaHiringResourcesLeaf = ({
  title,
  iconTitle,
  resources,
  onTick = () => {},
  excludedResources = [],
  isRecap = false,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const [isEmpty, setIsEmpty] = useState(false);
  useEffect(() => {
    let count = 0;
    for (let i = 0; i < resources?.length; i++) {
      if (excludedResources.includes(resources[i].id)) count++;
    }
    if (count === resources?.length) setIsEmpty(true);
    else setIsEmpty(false);
  }, [excludedResources, resources]);
  return (
    <View>
      <AppText
        color={currentTheme?.theme?.orange}
        style={{
          fontWeight: "bold",
          // fontSize: currentTheme?.theme?.large_font_size,
          marginLeft: 10,
        }}
        wrapperStyle={{
          marginBottom: 10,
        }}
        // iconSize={18}
        // leftIcon={AppAssets?.icons[iconTitle]}
      >
        {title}
      </AppText>
      {isEmpty && isRecap ? (
        <AppText
          wrapperStyle={{
            marginLeft: 10,
          }}
        >
          No resources will be imported
        </AppText>
      ) : (
        resources?.map((u) => {
          if ((isRecap && !excludedResources?.includes(u?.id)) || !isRecap)
            return (
              <QaHiringResourcesInstancesLeaf
                key={u?.id}
                u={u}
                onTick={(_v) => onTick(u, _v)}
                isTicked={excludedResources?.includes(u?.id) ? false : true}
                isRecap={isRecap}
              />
            );
          else {
            return <></>;
          }
        })
      )}
    </View>
  );
};

export default QaHiringResourcesLeaf;
